export enum IntensiteDefaut {
    FAIBLE = 'Faible',
    MOYENNE = 'Moyenne',
    FORTE = 'Forte'
}
